document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('StickyProductBar');
  const stickyButton = document.getElementById('StickyAtcButton');
  const stickyPromoText = document.getElementById('StickyPromoText');
  const stickyPrice = document.getElementById('StickyProductPrice');

  if (!stickyBar || !stickyButton) return;

  function findMainAddToCartForm() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');

    for (const form of forms) {
      if (form.id !== 'StickyProductForm') {
        return form;
      }
    }

    return null;
  }

  function findMainAddToCartButton() {
    const mainForm = findMainAddToCartForm();
    if (!mainForm) return null;

    return (
      mainForm.querySelector('button[type="submit"]') ||
      mainForm.querySelector('[name="add"]')
    );
  }

  function findMainVariantInput() {
    const mainForm = findMainAddToCartForm();
    if (!mainForm) return null;

    return mainForm.querySelector('input[name="id"]');
  }

  function formatMoney(cents) {
    if (typeof cents === 'undefined' || cents === null) return '';

    const amount = Number(cents) / 100;

    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function cleanButtonText(text) {
    if (!text) return '';

    const cleaned = text.replace(/\s+/g, ' ').trim();

    if (/added/i.test(cleaned)) return 'ADD TO CART';

    return cleaned;
  }

  function syncPriceFromMainForm() {
    const mainVariantInput = findMainVariantInput();
    if (!mainVariantInput) return;

    const variantId = mainVariantInput.value;
    if (!variantId || !window.meta || !window.meta.product || !window.meta.product.variants) return;

    const variant = window.meta.product.variants.find(function (item) {
      return String(item.id) === String(variantId);
    });

    if (variant && stickyPrice) {
      stickyPrice.textContent = formatMoney(variant.price);
    }
  }

  function syncStickyFromMainForm() {
    const mainButton = findMainAddToCartButton();
    if (!mainButton) return;

    const text = cleanButtonText(mainButton.textContent);

    if (text) {
      stickyButton.textContent = text;
    }

    const disabled =
      mainButton.disabled ||
      mainButton.hasAttribute('disabled') ||
      /sold out/i.test(text);

    stickyButton.disabled = disabled;
    stickyButton.classList.toggle('is-disabled', disabled);
  }

  function syncPromoFromBanner() {
    if (!stickyPromoText) return;

    const selectors = [
      '.announcement-bar',
      '.announcement-banner',
      '.promo-banner',
      '.header-announcement',
      '[class*="announcement"]',
      '[class*="promo"]'
    ];

    let source = null;

    for (const selector of selectors) {
      const elements = document.querySelectorAll(selector);

      for (const el of elements) {
        if (!stickyBar.contains(el) && el.innerText && el.innerText.trim().length > 0) {
          source = el;
          break;
        }
      }

      if (source) break;
    }

    if (!source) return;

    const lines = source.innerText
      .split('\n')
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);

    if (lines.length > 0) {
      stickyPromoText.textContent = lines[0];
    }
  }

  function toggleStickyVisibility() {
    const mainButton = findMainAddToCartButton();
    if (!mainButton) return;

    const rect = mainButton.getBoundingClientRect();
    const passedMainButton = rect.bottom < 0;

    stickyBar.classList.toggle('is-visible', passedMainButton);
    stickyBar.setAttribute('aria-hidden', passedMainButton ? 'false' : 'true');
  }

  stickyButton.addEventListener('click', function (event) {
    const mainButton = findMainAddToCartButton();

    if (!mainButton || mainButton.disabled) {
      event.preventDefault();
      return;
    }

    mainButton.click();
  });

  syncStickyFromMainForm();
  syncPriceFromMainForm();
  syncPromoFromBanner();
  toggleStickyVisibility();

  window.addEventListener('scroll', toggleStickyVisibility, { passive: true });
  window.addEventListener('resize', toggleStickyVisibility);

  document.addEventListener('change', function () {
    setTimeout(function () {
      syncStickyFromMainForm();
      syncPriceFromMainForm();
      toggleStickyVisibility();
    }, 120);
  });

  document.addEventListener('variant:change', function () {
    setTimeout(function () {
      syncStickyFromMainForm();
      syncPriceFromMainForm();
      toggleStickyVisibility();
    }, 120);
  });

  const observer = new MutationObserver(function () {
    syncStickyFromMainForm();
    syncPriceFromMainForm();
    toggleStickyVisibility();
  });

  const observeLater = function () {
    const mainButton = findMainAddToCartButton();

    if (mainButton) {
      observer.observe(mainButton, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });
    }
  };

  observeLater();
  setTimeout(observeLater, 500);
  setTimeout(observeLater, 1200);
});